import React, { useState, useEffect } from 'react';
import {
    Button,
    Icon,
} from '../../../../components/Component'; // Assuming Icon is here, adjust if not
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';

const LeadsDataTableHeaderTools = ({
    itemsPerPage,
    sortDirection, // 'ASC' or 'DESC'
    initialSearchTerm,
    isSearchVisible, // boolean to control search input visibility
    isCompactView, // boolean for the compact settings dropdown (tablesm)
    onItemsPerPageChange,
    onSortDirectionChange, // Should accept 'ASC' or 'DESC'
    onSearchSubmit, // callback with search term
    onToggleSearchVisibility,
    onToggleCompactView, // callback to toggle the compact view (tablesm)
    // onSortByChange, // New callback if we want to change sort_by field
}) => {
    const [internalSearchTerm, setInternalSearchTerm] = useState(initialSearchTerm || '');

    useEffect(() => {
        setInternalSearchTerm(initialSearchTerm || '');
    }, [initialSearchTerm]);

    const handleSearchInputChange = (e) => {
        setInternalSearchTerm(e.target.value);
    };

    const handleSearchKeyDown = (e) => {
        if (e.key === 'Enter') {
            onSearchSubmit(internalSearchTerm);
        }
    };

    const handleSearchButtonClick = () => {
        onSearchSubmit(internalSearchTerm);
    };

    const handleClearSearch = () => {
        setInternalSearchTerm('');
        onSearchSubmit(''); // Notify parent that search is cleared
        if (isSearchVisible) { // Only toggle if it's currently visible
            onToggleSearchVisibility();
        }
    };


    return (
        <div className="card-inner position-relative card-tools-toggle">
            <div className="card-title-group">
                <div className="card-tools">
                    {/* Placeholder for any tools that might go on the left */}
                </div>
                <div className="card-tools me-n1">
                    <ul className="btn-toolbar gx-1">
                        <li>
                            <a
                                href="#search"
                                onClick={(ev) => {
                                    ev.preventDefault();
                                    onToggleSearchVisibility();
                                }}
                                className="btn btn-icon search-toggle toggle-search"
                            >
                                <Icon name="search"></Icon>
                            </a>
                        </li>
                        <li className="btn-toolbar-sep"></li>
                        <li>
                            <div className="toggle-wrap">
                                <Button
                                    className={`btn-icon btn-trigger toggle ${isCompactView ? 'active' : ''}`}
                                    onClick={() => onToggleCompactView(!isCompactView)} // Toggle based on current state
                                >
                                    <Icon name="menu-right"></Icon>
                                </Button>
                                <div className={`toggle-content ${isCompactView ? 'content-active' : ''}`}>
                                    <ul className="btn-toolbar gx-1">
                                        <li className="toggle-close">
                                            <Button
                                                className="btn-icon btn-trigger toggle"
                                                onClick={() => onToggleCompactView(false)} // Always close
                                            >
                                                <Icon name="arrow-left"></Icon>
                                            </Button>
                                        </li>
                                        <li>
                                            <UncontrolledDropdown>
                                                <DropdownToggle tag="a" className="btn btn-trigger btn-icon dropdown-toggle">
                                                    <Icon name="setting" />
                                                </DropdownToggle>
                                                <DropdownMenu end className="dropdown-menu-xs">
                                                    <ul className="link-check">
                                                        <li>
                                                            <span>Show</span>
                                                        </li>
                                                        {[10, 15, 50, 100].map((num) => (
                                                            <li className={itemsPerPage === num ? 'active' : ''} key={num}>
                                                                <DropdownItem
                                                                    tag="a"
                                                                    href="#dropdownitem"
                                                                    onClick={(ev) => {
                                                                        ev.preventDefault();
                                                                        onItemsPerPageChange(num);
                                                                    }}
                                                                >
                                                                    {num}
                                                                </DropdownItem>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                    <ul className="link-check">
                                                        <li>
                                                            <span>Order</span>
                                                        </li>
                                                        <li className={sortDirection === 'DESC' ? 'active' : ''}>
                                                            <DropdownItem
                                                                tag="a"
                                                                href="#dropdownitem"
                                                                onClick={(ev) => {
                                                                    ev.preventDefault();
                                                                    onSortDirectionChange('DESC');
                                                                    // onSortByChange('createdAt'); // If we want to control sort_by field
                                                                }}
                                                            >
                                                                DESC
                                                            </DropdownItem>
                                                        </li>
                                                        <li className={sortDirection === 'ASC' ? 'active' : ''}>
                                                            <DropdownItem
                                                                tag="a"
                                                                href="#dropdownitem"
                                                                onClick={(ev) => {
                                                                    ev.preventDefault();
                                                                    onSortDirectionChange('ASC');
                                                                    // onSortByChange('createdAt'); // If we want to control sort_by field
                                                                }}
                                                            >
                                                                ASC
                                                            </DropdownItem>
                                                        </li>
                                                    </ul>
                                                </DropdownMenu>
                                            </UncontrolledDropdown>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div className={`card-search search-wrap ${isSearchVisible ? 'active' : ''}`}>
                <div className="card-body">
                    <div className="search-content">
                        <Button
                            className="search-back btn-icon toggle-search active bg-transparent text-secondary"
                            onClick={handleClearSearch}
                        >
                            <Icon name="arrow-left"></Icon>
                        </Button>
                        <input
                            type="text"
                            className="border-transparent form-focus-none form-control ps-5 bg-transparent text-secondary"
                            placeholder="Search User by name or email or phone"
                            value={internalSearchTerm}
                            onChange={handleSearchInputChange}
                            onKeyDown={handleSearchKeyDown}
                        />
                        <Button
                            onClick={handleSearchButtonClick}
                            className="search-submit btn-icon bg-transparent text-secondary border-0"
                        >
                            <Icon name="search"></Icon>
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LeadsDataTableHeaderTools;